import BoardListContext from '@/context/apps/board/BoardListContext';
import { useTranslation } from 'next-i18next/pages';
import { useContext } from 'react';

import {
  NEWS_CATEGORY_ALL_ID,
  type NewsCategoryFilterOption,
} from '@/utils/newsCategoryFilter';

import BoardListWithPagintaion from '@/components/apps/board/list/BoardListWithPagintaion';
import Area from '@/components/apps/layouts/shared/Area';
import Subtop from '@/components/apps/ui/subtop/Subtop';

import NewsCategoryFilter from './NewsCategoryFilter';

type Props = {
  categoryFilterOptions: ReadonlyArray<NewsCategoryFilterOption>;
  filterPath: string;
  getPageHref: (page: number) => string;
};

export default function NewsBoardList({
  categoryFilterOptions,
  filterPath,
  getPageHref,
}: Props) {
  const { t } = useTranslation('common');
  const { bdData, bcListData, bcNoticeListData, bcatsData } =
    useContext(BoardListContext);
  const hasSelectedCategory = categoryFilterOptions.some(
    (option) => option.isSelected && option.id !== NEWS_CATEGORY_ALL_ID,
  );

  return (
    <div className="subtop-wave-bg">
      <Subtop title={t(bdData.name)} />

      <Area>
        <div className="pt-[60px] lg:pt-[100px]">
          <NewsCategoryFilter options={categoryFilterOptions} />

          <BoardListContext.Provider
            value={{ bdData, bcListData, bcNoticeListData, bcatsData }}
          >
            <BoardListWithPagintaion
              emptyTitleText={
                hasSelectedCategory
                  ? t('이 분야의 소식이 아직 없어요')
                  : undefined
              }
              filterPath={filterPath}
              getPageHref={getPageHref}
            />
          </BoardListContext.Provider>
        </div>
      </Area>
    </div>
  );
}
